"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WavyWaves = void 0;

var _react = require("react");

var _reactApexcharts = _interopRequireDefault(require("react-apexcharts"));

require("./styles.css");

var _options = require("./options");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var WavyWaves = function WavyWaves(_ref) {
  var color = _ref.color,
      direction = _ref.direction,
      duration = _ref.duration;

  var _useState = (0, _react.useState)([3, 1, 2, 1, 3]),
      _useState2 = _slicedToArray(_useState, 2),
      seriesA = _useState2[0],
      setSeriesA = _useState2[1];

  var _useState3 = (0, _react.useState)([1, 3, 2, 3, 2]),
      _useState4 = _slicedToArray(_useState3, 2),
      seriesB = _useState4[0],
      setSeriesB = _useState4[1];

  var options = (0, _options.getOptions)(color, duration);
  (0, _react.useEffect)(function () {
    setSeriesB([3, 3, 3, 3, 3]);
    setTimeout(function () {
      return setSeriesA([0, 0, 0, 0, 0]);
    }, duration / 2); // half total animation
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    id: "react-wavy-transitions__waves",
    className: "react-wavy-transitions__waves",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "".concat(direction, " react-wavy-transitions__first"),
      style: {
        animationDuration: "".concat(duration, "ms")
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactApexcharts.default, {
        options: options,
        series: [{
          name: "series-1",
          data: seriesA
        }],
        type: "area",
        width: "100%",
        height: "100%"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "".concat(direction, " react-wavy-transitions__second"),
      style: {
        animationDuration: "".concat(duration, "ms")
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactApexcharts.default, {
        options: options,
        series: [{
          name: "series-1",
          data: seriesB
        }],
        type: "area",
        width: "100%",
        height: "100%"
      })
    })]
  });
};

exports.WavyWaves = WavyWaves;